"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableClaims = void 0;
exports.availableClaims = [
    {
        id: '0',
        claimType: 'full',
        name: 'Full Control',
        description: 'Allows the user to do anything',
        appliesTo: ['org'],
    },
    {
        id: '1',
        claimType: 'createItinerary',
        name: 'Create Itinerary',
        description: 'Allows the user to create an itinerary',
        appliesTo: ['org'],
    },
    {
        id: '2',
        claimType: 'editItinerary',
        name: 'Edit Itinerary',
        description: 'Allows the user to edit an itinerary',
        appliesTo: ['org', 'itin', 'section', 'itinTag'],
    },
    {
        id: '3',
        claimType: 'deleteItinerary',
        name: 'Delete Itinerary',
        description: 'Allows the user to delete an itinerary',
        appliesTo: ['org', 'itin'],
    },
    {
        id: '4',
        claimType: 'createUser',
        name: 'Create User',
        description: 'Allows the user to create a user',
        appliesTo: ['org'],
    },
    {
        id: '5',
        claimType: 'editUser',
        name: 'Edit User',
        description: 'Allows the user to edit a user',
        appliesTo: ['org'],
    },
    {
        id: '6',
        claimType: 'deleteUser',
        name: 'Delete User',
        description: 'Allows the user to delete a user',
        appliesTo: ['org'],
    },
    {
        id: '7',
        claimType: 'modifyClaims',
        name: 'Modify Claims',
        description: 'Allows the user to modify systems claims',
        appliesTo: ['org'],
    },
    {
        id: '8',
        claimType: 'accessHub',
        name: 'Access Coordinator Hub',
        description: 'Allows the user to access the hub',
        appliesTo: ['org'],
    },
    {
        id: '9',
        claimType: 'chatAccess',
        name: 'Chat Access',
        description: 'Allows the user to access the chat feature',
        appliesTo: ['org'],
    },
    {
        id: '10',
        claimType: 'viewTeamPage',
        name: 'View Team Page',
        description: 'Allows the user to view the team page',
        appliesTo: ['org'],
    },
    {
        id: '11',
        claimType: 'editCostings',
        name: 'Edit Costing',
        description: 'Allows the user to edit costs',
        appliesTo: ['org'],
    },
    {
        id: '12',
        claimType: 'viewCostings',
        name: 'View Costings',
        description: 'Allows the user to see costs and budgets',
        appliesTo: ['org'],
    },
    {
        id: '13',
        claimType: 'guestMode',
        name: 'Adding guests',
        description: 'Allows you to add guest users to your itinerary',
        appliesTo: ['org'],
    },
    {
        id: '14',
        claimType: 'generatePDF',
        name: 'Generating PDFs',
        description: 'Generate PDFs of your itineraries and reports',
        appliesTo: ['org'],
    },
    {
        id: '15',
        claimType: 'theme',
        name: 'Theming',
        description: 'Customize the theme of your account interface',
        appliesTo: ['org'],
    },
    {
        id: '16',
        claimType: 'settingsPage',
        name: 'Settings Page',
        description: 'To be able to access to the settings page of your org',
        appliesTo: ['org'],
    },
    {
        id: '17',
        claimType: 'plannerPage',
        name: 'Planner Page',
        description: 'To be able to access to the planner table of your org',
        appliesTo: ['org'],
    },
    {
        id: '18',
        claimType: 'itineraryTagAdmin',
        name: 'Tag Admin',
        description: 'Allows the user to create and delete tags',
        appliesTo: ['org'],
    },
    {
        id: '19',
        claimType: 'userPrivateInfoViewer',
        name: 'Detailed user info management',
        description: 'Allows user to able to view user private information.',
        appliesTo: ['org'],
    },
    {
        id: '20',
        claimType: 'manageGroupChat',
        name: 'Managing group chats',
        description: 'Allows users to be able to manage organisation group chats.',
        appliesTo: ['org'],
    },
    {
        id: '21',
        claimType: 'deleteGroupChat',
        name: 'Deleting group chats',
        description: 'Allows users to be able to delete organisation group chats.',
        appliesTo: ['org'],
    },
];
